import React from "react";

export const TrackesMenuIcon = () => {
    return (
        <svg width="24" height="13" viewBox="0 0 24 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M23.5294 7.7006H14.1176V5.2506H23.5294V7.7006ZM23.5294 0.350586H14.1176V2.80059H23.5294V0.350586ZM14.1176 12.6006H23.5294V10.1506H14.1176V12.6006ZM11.7647 2.80059V10.1506C11.7647 11.4981 10.7059 12.6006 9.41176 12.6006H2.35294C1.05882 12.6006 0 11.4981 0 10.1506V2.80059C0 1.45309 1.05882 0.350586 2.35294 0.350586H9.41176C10.7059 0.350586 11.7647 1.45309 11.7647 2.80059ZM10 10.1506L7.35294 6.4756L5.29412 9.24411L3.82353 7.39435L1.76471 10.1506H10Z" fill="#171725" fillOpacity="0.5" />
        </svg>
    )
}
